<div class="fake-mode-cover" *ngIf="isFakeMode"></div>
<section class="db-ecommerce-settings-wrapper">
  <ng-container *ngIf="!loading; else loadingTemp">
    <div class="db-ecommerce-settings-header">
      <div class="actions-container">
        <button class="ds-btn"
                (click)="discardForm()"
                [ngClass]="{'ds-btn-disabled': false}">
          {{'text_productsDiscardBtn' | dbText}}
        </button>
        <button class="ds-btn-black"
                (click)="saveSettings()">
          {{'text_saveTags' | dbText}}
        </button>
      </div>
    </div>
    <div class="db-ecommerce-settings-body" [formGroup]="settingsForm">
      <div class="db-ecommerce-settings-title mb25">
        <span>{{'text_ecommerceSettingsTitle'|dbText}}</span>
      </div>
      <ng-container formArrayName="settings">
        <div class="db-ecommerce-settings-form-unit mb30" [formGroup]="$any(settingsFormArray.at(2))">
          <div class="db-ecommerce-settings-dropdown-container">
            <div class="field-label">
              {{'text_ecommerceBusinessRegion'|dbText}}
            </div>
            <ds-dropdown [selectOnEnter]="true"
                         (onOptionChoose)="regionSelected($event)"
                         [dsDropdownSearch]="true"
                         [dsDropdownSelectedInputHolder]="true"
                         formControlName="value"
                         [dsDropdownSelectedInputHolder]="true"
                         [value]="settingsFormArray.at(2).get('value').valueChanges|async"
                         [dsDropdownOptions]="dropdownOptions['woocommerce_default_country']">
            </ds-dropdown>
          </div>
        </div>
        <div class="db-ecommerce-settings-form-unit mb30" [formGroup]="$any(settingsFormArray.at(3))">
          <div class="db-ecommerce-settings-dropdown-container">
            <div class="field-label">
              {{'text_ecommerceCurrency'|dbText}}
            </div>
            <ds-dropdown [selectOnEnter]="true"
                         formControlName="value"
                         [dsDropdownSearch]="true"
                         [dsDropdownSelectedInputHolder]="true"
                         [value]="settingsFormArray.at(3).get('value').valueChanges|async"
                         [dsDropdownOptions]="dropdownOptions['woocommerce_currency']">
            </ds-dropdown>
          </div>
        </div>
        <div class="db-ecommerce-settings-form-unit mb30">
          <div class="db-ecommerce-settings-dropdown-container" [formGroup]="$any(settingsFormArray.at(0))">
            <div class="field-label">
              {{'text_ecommerceWeightUnit'|dbText}}
            </div>
            <ds-dropdown [selectOnEnter]="true"
                         formControlName="value"
                         [dsDropdownSelectedInputHolder]="true"
                         [value]="settingsFormArray.at(0).get('value').valueChanges|async"
                         [dsDropdownOptions]="dropdownOptions['woocommerce_weight_unit']">
            </ds-dropdown>
          </div>
          <div class="db-ecommerce-settings-dropdown-container " [formGroup]="$any(settingsFormArray.at(1))">
            <div class="field-label">
              {{'text_ecommerceDimensionsUnit'|dbText}}
            </div>
            <ds-dropdown [selectOnEnter]="true"
                         formControlName="value"
                         [dsDropdownSelectedInputHolder]="true"
                         [value]="settingsFormArray.at(1).get('value').valueChanges|async"
                         [dsDropdownOptions]="dropdownOptions['woocommerce_dimension_unit']">
            </ds-dropdown>
          </div>
        </div>
        <div class="db-ecommerce-settings__taxation">
          <h3>{{ 'text_taxation' | dbText }}<span class="ml5" [ngClass]="{'active': !!connectTaxesEnabled, 'inactive': !connectTaxesEnabled}"
          >{{ (!!connectTaxesEnabled ? 'text_active' : 'text_inactive') | dbText }}</span></h3>
          <p class="mt10">
            <span>{{ 'text_ratesWillBeConfigurableAndTaxesWillBeCalculated' | dbText }}</span>
            <span class="manage" [routerLink]="'../tax'" [queryParams]="{'tab': 'settings'}">{{ 'text_manage' | dbText }}</span>
          </p>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #loadingTemp>
    <db-loading-screen></db-loading-screen>
  </ng-template>
</section>
